var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(483.5 -1203.362)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4606e",
    d: "M-480 1209.862v19h23v-19h-23zm14.457 4.05a6.268 6.369 44.945 0 1 4.361 1.815 6.268 6.369 44.945 0 1-.072 8.936 6.268 6.369 44.945 0 1-8.935.072 6.268 6.369 44.945 0 1 .072-8.935 6.268 6.369 44.945 0 1 4.574-1.887z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a5ff",
    d: "M-480 1205.862h23v4h-23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0079fd",
    d: "M-480 1205.862v1.5h21.5v2.5h1.5v-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe2b70",
    d: "M-458.5 1209.862v19h1.5v-19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M-480 1209.862h23"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    cx: -478,
    cy: 1207.862,
    r: 0.5,
    fill: "#fe2b70",
    color: "#000",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -476,
    cy: 1207.862,
    r: 0.5,
    fill: "#f9d259",
    color: "#000",
    overflow: "visible",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    cx: -474,
    cy: 1207.862,
    r: 0.5,
    fill: "#f9d259",
    color: "#000",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeDashoffset: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M-457 1215.77v13.092h-23v-23h23v5.512m0 1.888V1213.926",
    color: "#000",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#f8e71b",
    d: "M-467.5 1218.362h2v9h-2zM-463.5 1220.362h2v7h-2zM-471.5 1225.362h2v2h-2zM-475.5 1222.362h2v5h-2z",
    color: "#000",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01d1ff",
    fillRule: "evenodd",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M-459.72 1226.113a1.36 1.36 89.982 0 0 .028 1.92l5.333 5.332a1.36 1.36 89.982 1 0 1.922-1.922l-5.332-5.332a1.36 1.36 89.982 0 0-1.95 0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M-461.597 1224.215a.45.45 0 0 0 .009.64l2.345 2.345c.427.44 1.08-.214.64-.641l-2.344-2.345a.454.454 0 0 0-.65 0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -1192.115,
    cy: 533.526,
    fill: "none",
    stroke: "#01d1ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "#000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    overflow: "visible",
    rx: 5.61,
    ry: 5.52,
    transform: "rotate(-45.001) skewX(-.002)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01d1ff",
    fillRule: "evenodd",
    d: "M-459.72 1226.113a1.36 1.36 89.982 0 0 .028 1.92l5.333 5.332a1.36 1.36 89.982 1 0 1.922-1.922l-5.332-5.332a1.36 1.36 89.982 0 0-1.95 0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a5ff",
    fillRule: "evenodd",
    d: "M-459.718 1226.114a1.36 1.36 89.982 0 0-.25.36 1.36 1.36 89.982 0 1 1.559.278l5.331 5.331a1.36 1.36 89.982 0 1 .28 1.56 1.36 1.36 89.982 0 0 .36-2.2l-5.33-5.332a1.36 1.36 89.982 0 0-1.95 0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M-459.72 1226.113a1.36 1.36 89.982 0 0 .028 1.92l5.333 5.332a1.36 1.36 89.982 1 0 1.922-1.922l-5.332-5.332a1.36 1.36 89.982 0 0-1.95 0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a5ff",
    d: "M-470.01 1215.906c-.095.095-.18.196-.268.296 2.43-2.141 6.125-2.09 8.419.203 2.294 2.294 2.344 5.99.203 8.419.1-.088.201-.172.296-.267 2.416-2.416 2.452-6.327.064-8.715s-6.299-2.352-8.714.064z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -1192.115,
    cy: 533.526,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    color: "#000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    overflow: "visible",
    rx: 6.369,
    ry: 6.268,
    transform: "rotate(-45.001) skewX(-.002)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.ffbf7e52bbec93b913091228f869c6cf.svg";
export { ForwardRef as ReactComponent };